export default __webpack_public_path__ + "static/media/new_logo_simba.18933cc6.svg";